import { Component, Input, inject, AfterViewInit } from '@angular/core';

import { AppShellUIService } from '@campus/components';
import { EduContentTOCInterface } from '@campus/dal';
import '@diekeure/dcr-components/dcr-state-layer.js';
import '@diekeure/dcr-components/dcr-focus-ring.js';
import '@diekeure/dcr-components/dcr-icon.js';
import '@diekeure/dcr-components/dcr-inline-button.js';
import '@diekeure/dcr-components/dcr-filled-button.js';
import { take, tap } from 'rxjs';

@Component({
    selector: 'campus-toc-trigger',
    templateUrl: './toc-trigger.component.html',
    styleUrls: ['./toc-trigger.component.scss'],
    standalone: false
})
export class TocTriggerComponent implements AfterViewInit {
  @Input() toc: EduContentTOCInterface;
  @Input() active = false;
  @Input() isAdaptive = false;

  public appShellUIService = inject(AppShellUIService);

  ngAfterViewInit() {
    if (!this.toc) {
      this.openSideSheet();
    }
  }

  public openSideSheet() {
    this.appShellUIService.visibleItemsConfig$.pipe(take(1)).subscribe((config) => {
      if (config.showSideSheet) {
        this.appShellUIService.highlightSideSheet();
      }
    });
    this.appShellUIService.openSideSheet(true);
  }
}
